<div class="sh-alert" [ngClass]="'sh-alert--' + variant" role="alert">
  <div class="sh-alert__icon">
    <i class="bi" [ngClass]="iconClass"></i>
  </div>

  <div class="sh-alert__content">
    <div *ngIf="title">
      <b class="sh-alert__title">{{ title }}</b>
    </div>
    <div class="sh-alert__desc">
      <ng-content></ng-content>
    </div>
  </div>

  <button
    *ngIf="closable"
    type="button"
    class="sh-alert__close"
    aria-label="Cerrar"
    (click)="close()">
    <i class="bi bi-x"></i>
  </button>
</div>
